import React from 'react';

const LOGOS = [
    { name: 'ABF', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/abf.png') },
    { name: 'BR', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/br.png') },
    { name: 'Cyber DueDil', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/cyberduedil.png') },
    { name: 'Fin-house', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/finhouse.png') },
    { name: 'Fractionality', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/fractionality.png') },
    { name: 'Freshbat', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/freshbat.png') },
    { name: 'GenFinance', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/gen.png') },
    { name: 'Green Ripple', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/green_ripple.png') },
    { name: 'Intelect', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/intelect.png') },
    { name: 'Kiss the fish', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/kiss_the_fish.png') },
    { name: 'Nume', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/nume.png') },
    { name: 'SU2SU', logo: require('../../../../images/landing-pages/partner/appstore-partner-logos/su2su.png') },
];

const PartnerLogosSection = () => (
    <section className="lp-partner-logos-sec" style={{ marginBottom: 0 }}>
        <h2 className="lp-partner-logos-title">Current AppStore Partners</h2>
        <div className="lp-partner-logos-strip">
            <div className="lp-partner-logos-track">
                {[...LOGOS, ...LOGOS].map((p, i) => (
                    <span className="lp-partner-logo-chip" key={i}><img src={p.logo} alt={p.name} /></span>
                ))}
            </div>
        </div>
    </section>
);

export default PartnerLogosSection;
